import { render, staticRenderFns } from "./NewTabA11y.vue?vue&type=template&id=14121ba3&scoped=true&"
import script from "./NewTabA11y.vue?vue&type=script&lang=js&"
export * from "./NewTabA11y.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14121ba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14121ba3')) {
      api.createRecord('14121ba3', component.options)
    } else {
      api.reload('14121ba3', component.options)
    }
    module.hot.accept("./NewTabA11y.vue?vue&type=template&id=14121ba3&scoped=true&", function () {
      api.rerender('14121ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/a11y/NewTabA11y.vue"
export default component.exports